
<template>
  <el-card shadow="never" class="box-card">
    <div slot="header" class="clearfix">
      <span>{{name}}</span>
    </div>
    <div class="text item paramContainer">
        <el-row :gutter="10">
        <el-col class="paramNameCol" :span="8">
            CSS Selector
        </el-col>
        <el-col :span="16">
            <el-input
                placeholder="Please input css selector"
                v-model="model.params.selector"
                clearable>
            </el-input>    
        </el-col>
      </el-row>  
      <el-row :gutter="10">
        <el-col class="paramNameCol" :span="8">
            xPATH
        </el-col>
        <el-col :span="16">
            <el-input
                placeholder="Please input xpah"
                v-model="model.params.xpath"
                clearable>
            </el-input>   
        </el-col>
      </el-row>  
    <el-row :gutter="8">
        <el-col class="paramNameCol" :span="8">
            Mode
        </el-col>
        <el-col :span="16">
            <el-select v-model="model.params.mode"  placeholder="Select mode">
                <el-option
                v-for="item in modes"
                :key="item"
                :label="item"
                :value="item">
                </el-option>
            </el-select>
        </el-col>
    </el-row>
    <el-row :gutter="8">
        <el-col class="paramNameCol" :span="8">
            Source
        </el-col>
        <el-col :span="16">
            <el-select v-model="model.params.source"  placeholder="Select source">
                <el-option
                v-for="item in sources"
                :key="item"
                :label="item"
                :value="item">
                </el-option>
            </el-select>
        </el-col>
    </el-row>
    <el-row :gutter="8">
        <el-col class="paramNameCol" :span="8">
            Values
        </el-col>
        <el-col :span="16">
            <el-input
                type="textarea"
                placeholder=""
                autosize
                v-model="queries">
            </el-input>
        </el-col>
    </el-row>
    <el-row :gutter="8">
        <el-col class="paramNameCol" :span="8">
            Override
        </el-col>
        <el-col class="checkCol" :span="16">
            <el-checkbox  v-model="model.params.override"></el-checkbox>        
        </el-col>
    </el-row>
    <el-row :gutter="8">
        <el-col class="paramNameCol" :span="8">
            Submit
        </el-col>
        <el-col class="checkCol" :span="16">
            <el-checkbox  v-model="model.params.submit"></el-checkbox>        
        </el-col>
    </el-row>
      <div class="tip">
          {{desc}}
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'InsertMulti',
  data () {
    return {
        name:'Insert multi',
        modes: ['random', 'by_index'],
        sources: ['buffer','keyboard','mouse'],
        textarea: '',
        queries: this.getQueries()
    }
  }, 
  props: {
      model: {
          type: Object,
          default: () => {}
      },
  },
  methods: {
    getQueries() {
        //var lines = area.value.replace(/\r\n/g,"\n").split("\n");
        if (this.model.params.values.length === 0) {
            return "";
        }

        return this.model.params.values.join("\n");
    },
  },
  watch: {
    queries(newValue, oldValue) {
        this.model.params.values = newValue.replace(/\r\n/g,"\n").split("\n");
    }
  },
  computed: {
    ...mapState('bot', {
      bot: 'bot',
      project: 'project',
      error: 'error',
      loading: 'loading',
    }),
  },
  
  
}
</script>

<style lang="scss" scoped>
    .checkCol {
        margin-top:10px;
    }
</style>
